import React from 'react';
import { useSelector } from 'react-redux';

const Dyslipidemia = ({ exams }) => {
    const { profile } = useSelector((state) => state.auth);
    const gender = profile?.gender?.toUpperCase?.() || '';

    let colesterolMessage = '';
    let ldlMessage = '';
    let hdlMessage = '';
    let trigliceridosMessage = '';

    const toNumber = (v) => {
        if (v === null || v === undefined) return NaN;
        return typeof v === 'number' ? v : Number(v);
    };

    const getMessage = (type, raw) => {
        const value = toNumber(raw);
        if (Number.isNaN(value)) return '';

        if (type === 'Colesterol') {
            // Deseable < 200 mg/dl
            return value < 200 ? 'En rango' : 'Fuera de rango';
        }
        if (type === 'LDL') {
            // Meta general hasta 130 mg/dl (<= 130)
            return value <= 130 ? 'En rango' : 'Fuera de rango';
        }
        if (type === 'HDL') {
            // Femenino >= 50 mg/dl, Masculino >= 40 mg/dl
            const min = gender === 'F' ? 50 : gender === 'M' ? 40 : 45; // fallback neutro
            return value >= min ? 'En rango' : 'Fuera de rango';
        }
        if (type === 'Trigliceridos') {
            // Deseable < 150 mg/dl
            return value < 150 ? 'En rango' : 'Fuera de rango';
        }
        return '';
    };

    return (
        <>
            {exams.map((item, pos) => {
                colesterolMessage = getMessage('Colesterol', item?.currentLastResult?.Colesterol ?? null);
                ldlMessage = getMessage('LDL', item?.currentLastResult?.LDL ?? null);
                hdlMessage = getMessage('HDL', item?.currentLastResult?.HDL ?? null);
                trigliceridosMessage = getMessage('Trigliceridos', item?.currentLastResult?.Trigliceridos ?? null);

                return (
                    <React.Fragment key={pos}>
                        <tr>
                            <td>Colesterol</td>
                            <td>{item?.hasPreviousYear ? item?.previousLastResult?.Colesterol ?? '' : ''}</td>
                            <td>{item?.hasCurrentYear ? item?.currentLastResult?.Colesterol ?? '' : ''}</td>
                            <td>Menor a 200 mg/dl</td>
                            <td>{colesterolMessage}</td>
                        </tr>

                        <tr>
                            <td>LDL</td>
                            <td>{item?.hasPreviousYear ? item?.previousLastResult?.LDL ?? '' : ''}</td>
                            <td>{item?.hasCurrentYear ? item?.currentLastResult?.LDL ?? '' : ''}</td>
                            <td>Hasta 130 mg/dl</td>
                            <td>{ldlMessage}</td>
                        </tr>

                        <tr>
                            <td>HDL</td>
                            <td>{item?.hasPreviousYear ? item?.previousLastResult?.HDL ?? '' : ''}</td>
                            <td>{item?.hasCurrentYear ? item?.currentLastResult?.HDL ?? '' : ''}</td>
                            <td>Mayor 50 Femenino; Mayor 40 Masculino</td>
                            <td>{hdlMessage}</td>
                        </tr>

                        <tr>
                            <td>Triglicéridos</td>
                            <td>{item?.hasPreviousYear ? item?.previousLastResult?.Trigliceridos ?? '' : ''}</td>
                            <td>{item?.hasCurrentYear ? item?.currentLastResult?.Trigliceridos ?? '' : ''}</td>
                            <td>Menor a 150 mg/dl</td>
                            <td>{trigliceridosMessage}</td>
                        </tr>
                    </React.Fragment>
                );
            })}
        </>
    );
};

export default Dyslipidemia;
